import React from 'react'
import './Tomorrow.min.css'
const Sun2 = props => {

    const {sunrise2, sunset2}  = props.weather
    let sunriseTime = new Date(sunrise2 * 1000).getHours();
    let actualHour = new Date().getHours();
    let differentHour = actualHour - sunriseTime;
  
    let sunriseTime2 = new Date(sunrise2*1000);
    let sunsetTime2 = new Date(sunset2*1000);
    let differentTime = new Date(sunsetTime2.getTime() - sunriseTime2.getTime());
    let lenghtDay = (differentTime.getHours()) - 1;
    
   
    let number = Math.round(((differentHour * 100) / lenghtDay) / 10);
  
    
    if(number > 10 || number < 1){
        number = 0
    }
    let sunClass = "st" + number
 
   
    let a = document.getElementById("sun");
    a.setAttribute("class", sunClass)
    
    let stop = document.getElementById("stop")
    let number2 = "0." + number;
    if (number == 10){
        number2 = 1;
    } else if (number > 10){
        number2 = 0;
    }
   
    stop.setAttribute("offset",  number2)

    return(
        <div></div>
    )
}
export default Sun2;